import { useState } from 'react';
import { AVATAR_COLORS } from '../../lib/palette';
import { useChatStore } from '../../stores/chatStore';
import { useDmStore } from '../../stores/dmStore';
import { usePlayersStore } from '../../stores/playersStore';
import { useSessionStore } from '../../stores/sessionStore';
import './presence.css';

function colorOf(index: number): string {
  const value = AVATAR_COLORS[index % AVATAR_COLORS.length] ?? 0;
  return `#${value.toString(16).padStart(6, '0')}`;
}

/** Anwesenheitsliste: wer ist gerade im Buero. Klick startet eine Direktnachricht. */
export function PresenceSidebar() {
  const roster = usePlayersStore((s) => s.roster);
  const selfId = usePlayersStore((s) => s.selfId);
  const selfUserId = useSessionStore((s) => s.user?.id);
  // Auf dem Handy ist die Liste eingeklappt und zeigt nur die Zahl
  const [offen, setOffen] = useState(false);

  const startDm = (userId: string, displayName: string): void => {
    // Name mitgeben: ein noch leeres Gespraech steht in keiner
    // Konversationsliste und hiesse sonst bloss "Direktnachricht"
    useDmStore.getState().openConversation(userId, displayName);
    useChatStore.getState().setOpen(true);
  };

  return (
    <aside className={`presence${offen ? ' presence--offen' : ''}`} aria-label="Anwesende Personen">
      <button className="presence__pill" onClick={() => setOffen((o) => !o)} aria-expanded={offen}>
        Online <span className="presence__count">{roster.length}</span>
      </button>
      <h2 className="presence__title">
        Online <span className="presence__count">{roster.length}</span>
      </h2>
      <ul className="presence__list">
        {roster.map((entry) => {
          const isSelf = entry.id === selfId;
          return (
            <li key={entry.id} className="presence__item">
              <span className="presence__dot" style={{ background: colorOf(entry.avatarColor) }} aria-hidden="true" />
              <span className="presence__name">
                {entry.displayName}
                {entry.ringRequired && <span className="presence__dnd" title="Muss angeklingelt werden"> 🔕</span>}
                {isSelf && <em> (du)</em>}
              </span>
              {!isSelf && entry.userId !== selfUserId && (
                <button
                  className="presence__dm"
                  onClick={() => startDm(entry.userId, entry.displayName)}
                  title={`${entry.displayName} anschreiben`}
                  aria-label={`${entry.displayName} anschreiben`}
                >
                  ✉️
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </aside>
  );
}
